<template>
  <a-form @submit="handleSubmit" :form="form" class="form">
    <a-form-item
      v-show="false"
      label="id"
    >
      <a-input
        v-decorator="['id']"
      />
    </a-form-item>
    <a-row class="form-row" :gutter="16">
      <a-col :lg="6" :md="12" :sm="24">
        <a-form-item
          label="招标文件/工程量清单">
          <minio-upload :url="url" :fileListTemp="biddingFileList" @updateFileList="(data) => changeList(data,'biddingFileList')" v-decorator="['biddingFileList']" :is-show="showable"/>
        </a-form-item>
      </a-col>
      <a-col :xl="{span: 7, offset: 1}" :lg="{span: 8}" :md="{span: 12}" :sm="24">
        <a-form-item
          label="中标通知书">
          <minio-upload :url="url" :fileListTemp="winBiddingFileList" @updateFileList="(data) => changeList(data,'winBiddingFileList')" v-decorator="['winBiddingFileList']" :is-show="showable"/>
        </a-form-item>
      </a-col>
      <a-col :xl="{span: 9, offset: 1}" :lg="{span: 10}" :md="{span: 24}" :sm="24">
        <a-form-item
          label="施工合同">
          <minio-upload :url="url" :fileListTemp="constructionFileList" @updateFileList="(data) => changeList(data,'constructionFileList')" v-decorator="['constructionFileList']" :is-show="showable"/>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row class="form-row" :gutter="16">
      <a-col :lg="6" :md="12" :sm="24">
        <a-form-item
          label="甲方">
          <a-input
            placeholder="请输入"
            :disabled="showable"
            v-decorator="[ 'biddingPartyA' ]" />
        </a-form-item>
      </a-col>
      <a-col :xl="{span: 7, offset: 1}" :lg="{span: 8}" :md="{span: 12}" :sm="24">
        <a-form-item
          label="乙方">
          <a-input
            placeholder="请输入"
            :disabled="showable"
            v-decorator="[ 'biddingPartyB' ]" />
        </a-form-item>
      </a-col>
      <a-col :xl="{span: 9, offset: 1}" :lg="{span: 10}" :md="{span: 24}" :sm="24">
        <a-form-item
          label="合同额（元）">
          <a-input-number
            :precision="2"
            style="width: 100%"
            :min="0"
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['biddingContractAmount', {rules: [{required: false, message: '请输入合同额(最多输入两位小数)'}]}]" />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row class="form-row" :gutter="16">
      <a-col :lg="6" :md="12" :sm="24">
        <a-form-item
          label="工程地点">
          <a-input
            placeholder="请输入"
            :disabled="showable"
            v-decorator="[ 'biddingProjectLocation' ]" />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col>
        <a-form-item
          label="付款方式">
          <a-textarea
            placeholder="请输入"
            :disabled="showable"
            v-decorator="[ 'biddingPayMethod' ]" />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col>
        <a-form-item
          label="其它主要信息">
          <a-textarea
            placeholder="请输入"
            :disabled="showable"
            v-decorator="[ 'biddingOtherInfo' ]" />
        </a-form-item>
      </a-col>
    </a-row>
    <a-form-item v-if="showSubmit">
      <a-button htmlType="submit" >Submit</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import pick from 'lodash.pick'
import minioUpload from './minio-uplode'
import ATextarea from 'ant-design-vue/es/input/TextArea'
export default {
  name: 'BiddingRemarkForm',
  components: {
    ATextarea,
    minioUpload
  },
  props: {
    showSubmit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      showable: false,
      addable: false,
      editable: false,
      memberLoading: false,
      url: 'api/storage/upload',
      biddingFileList: [],
      winBiddingFileList: [],
      constructionFileList: []
    }
  },
  methods: {
    // 接受子组件中的参数，并保存到form中，可以直接提交
    changeList (data, str) {
      if (str === 'biddingFileList') {
        this.biddingFileList = data
        this.form.setFieldsValue({ biddingFileList: JSON.stringify(data) })
      }
      if (str === 'winBiddingFileList') {
        this.winBiddingFileList = data
        this.form.setFieldsValue({ winBiddingFileList: JSON.stringify(data) })
      }
      if (str === 'constructionFileList') {
        this.constructionFileList = data
        this.form.setFieldsValue({ constructionFileList: JSON.stringify(data) })
      }
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$notification['error']({
            message: 'Received values of form:',
            description: values
          })
        }
      })
    },
    loadData (data, type) {
      this.visible = true
      if (type && type === 'add') {
        this.showable = false
        this.addable = true
        this.type = type
      }
      if (type === 'edit') {
        this.showable = false
        this.editable = true
        this.type = type
      }
      if (type === 'show') {
        this.showable = true
        this.type = type
      }
      const { form: { setFieldsValue, resetFields } } = this
      if (['edit', 'show'].includes(type)) {
        this.confirmLoading = true
        const record = data
        this.biddingFileList = JSON.parse(record.biddingFileList)
        this.winBiddingFileList = JSON.parse(record.winBiddingFileList)
        this.constructionFileList = JSON.parse(record.constructionFileList)
        this.confirmLoading = false
        this.$nextTick(() => {
          setFieldsValue(pick(record, [
            'id',
            'biddingPartyA',
            'biddingPartyB',
            'biddingContractAmount',
            'biddingProjectLocation',
            'biddingPayMethod',
            'biddingOtherInfo'
          ]))
        })
      } else {
        resetFields()
      }
    }
  }
}
</script>

<style scoped>

</style>
